<script lang="ts">
    import { afterUpdate } from "svelte";
    import { portal } from "../utils/portal";

    export let text: string;
    export let data: DOMRect;

    const SPACE_FROM_VIEWPORT = 3; // Padding from the edge of the viewport
    const SPACE_FROM_ELEMENT = 3; // Padding from the target element

    let tooltipStyle = "";
    let tooltipElement: HTMLDivElement;

    function updateTooltipPosition() {
        if (data && tooltipElement) {
            const viewportWidth = document.documentElement.clientWidth;
            const viewportHeight = document.documentElement.clientHeight;

            let top = data.y - SPACE_FROM_ELEMENT;
            let left = Math.round(data.x + data.width / 2);

            const tooltipRect = tooltipElement.getBoundingClientRect();
            const tooltipWidth = tooltipRect.width;
            const tooltipHeight = tooltipRect.height;

            // Adjust for horizontal overflow with padding
            if (left - tooltipWidth / 2 < SPACE_FROM_VIEWPORT) {
                left = tooltipWidth / 2 + SPACE_FROM_VIEWPORT;
            } else if (
                left + tooltipWidth / 2 >
                viewportWidth - SPACE_FROM_VIEWPORT
            ) {
                left = viewportWidth - tooltipWidth / 2 - SPACE_FROM_VIEWPORT;
            }

            // Adjust for vertical overflow with padding
            if (top - tooltipHeight < SPACE_FROM_VIEWPORT) {
                top =
                    data.y + tooltipHeight + data.height + SPACE_FROM_VIEWPORT;
            } else if (top > viewportHeight - SPACE_FROM_VIEWPORT) {
                top = viewportHeight - SPACE_FROM_VIEWPORT;
            }

            tooltipStyle = `top: ${top}px; left: ${left}px; transform: translate(-50%, -100%)`;
        }
    }

    afterUpdate(() => {
        updateTooltipPosition();
    });
</script>

{#if text}
    <div
        use:portal
        class="tooltip"
        bind:this={tooltipElement}
        style={tooltipStyle}
    >
        {@html text}
    </div>
{/if}

<style>
    /* purgecss start ignore */
    @import "../extension/external.css";
    /* purgecss end ignore */
</style>
